import TCompanyRequest from './index.vue';

TCompanyRequest.install = app => {
  app.component(TCompanyRequest.name, TCompanyRequest);
};

export default TCompanyRequest;
